// extracted by mini-css-extract-plugin
module.exports = {"respondents_tabBlock":"companresearcherListItem_respondents_tabBlock__pCm2k","respondents__index":"companresearcherListItem_respondents__index__w4KlF"};